import type { ReactNode } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';
import type { VaultListStatus } from './vaultListStatus';

type VaultListStateProps = {
  status: VaultListStatus;
  onRetry: () => void;
  children: ReactNode;
};

export const VaultListState = ({
  status,
  onRetry,
  children,
}: VaultListStateProps) => {
  const { t } = useLocalization();

  if (status === 'loading') {
    return <Typography>{t('loading')}</Typography>;
  }

  if (status === 'error') {
    return (
      <Alert
        severity='error'
        action={
          <Button
            color='inherit'
            size='small'
            onClick={onRetry}
          >
            {t('retry')}
          </Button>
        }
      >
        {t('documentVault.vaultLoadError')}
      </Alert>
    );
  }

  return <>{children}</>;
};

export const VaultEmptyOverlay = () => {
  const { t } = useLocalization();

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography>{t('documentVault.noDocumentsFound')}</Typography>
    </Box>
  );
};
